import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { dbHelpers } from '../../db/database';
import { customersAPI } from '../../api/customers';
import syncService from '../../services/syncService';
import './CustomerForm.css';

function CustomerForm() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);
  
  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    is_active: true
  });

  useEffect(() => {
    if (isEdit) {
      loadCustomer();
    }
  }, [id]);

  async function loadCustomer() {
    try {
      const cust = await dbHelpers.getCustomerById(id);
      if (cust) {
        setCustomer(cust);
      }
    } catch (error) {
    }
  }

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    setCustomer(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    
    if (!customer.name) {
      alert('Please enter customer name');
      return;
    }
    
    setLoading(true);
    
    try {
      if (navigator.onLine) {
        if (isEdit) {
          await customersAPI.update(id, customer);
        } else {
          await customersAPI.create(customer);
        }
        alert('✅ Customer saved successfully!');
      } else {
        if (isEdit) {
          await dbHelpers.updateCustomer(id, customer);
        } else {
          await dbHelpers.addCustomer(customer);
        }
        alert('✅ Customer saved offline. Will sync when online.');
      }
      
      navigate('/customers');
    } catch (error) {
      alert('❌ Failed to save customer: ' + error.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="customer-form-container fade-in">
      <div className="form-header">
        <h1>{isEdit ? 'Edit Customer' : 'Add New Customer'}</h1>
        <button 
          onClick={() => navigate('/customers')} 
          className="btn-back"
        >
          ← Back
        </button>
      </div>

      <form onSubmit={handleSubmit} className="customer-form">
        <div className="form-grid">
          <div className="form-group">
            <label htmlFor="name">Customer Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={customer.name}
              onChange={handleChange}
              className="form-input"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={customer.email}
              onChange={handleChange}
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={customer.phone}
              onChange={handleChange}
              className="form-input"
            />
          </div>

          <div className="form-group full-width">
            <label htmlFor="address">Address</label>
            <textarea
              id="address"
              name="address"
              value={customer.address}
              onChange={handleChange}
              className="form-input"
              rows="3"
            />
          </div>

          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="is_active"
                checked={customer.is_active}
                onChange={handleChange}
              />
              <span>Active Customer</span>
            </label>
          </div>
        </div>

        <div className="form-actions">
          <button 
            type="button" 
            onClick={() => navigate('/customers')} 
            className="btn-cancel"
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="btn-save"
            disabled={loading}
          >
            {loading ? 'Saving...' : (isEdit ? 'Update Customer' : 'Add Customer')}
          </button>
        </div>
      </form>
    </div>
  );
}

export default CustomerForm;
